import { SEPARATOR, exactValidator, genericValidateName, uuidValidator } from './genericName';
export const validateName = genericValidateName([
    exactValidator('habitats'),
    uuidValidator(),
    exactValidator('meetingEntitlements'),
    uuidValidator(),
]);
export const NameToID = (name) => {
    validateName(name); // throws if invalid
    const parts = name.split(SEPARATOR);
    return {
        habitatID: parts[1],
        meetingEntitlementID: parts[3],
    };
};
